import ProfilerBarChart from '../../ProfilerBarChart/ProfilerBarChart';

/**
 * ComparableCompaniesChartView - Bar chart view for comparable companies
 *
 * Renders ProfilerBarChart component with:
 * - Sorted companies as bar chart data
 * - Parent company for comparison
 * - Interactive click handlers
 * - Sorting configuration
 *
 * This is the view component for the "chart" display mode.
 */
const ComparableCompaniesChartView = ({
  similarCompaniesBarChart,
  observableCompany,
  onSimilarCompanyDetailsClick,
  comparablesId,
  project,
  selectedSimilarCompaniesSort
}) => {
  return (
    <div className="similar-bar-chart-outer-wrap">
      <ProfilerBarChart
        companies={similarCompaniesBarChart}
        parentCompany={observableCompany}
        onCompanyClick={onSimilarCompanyDetailsClick}
        chartId={comparablesId}
        project={project}
        sort={selectedSimilarCompaniesSort}
      />
    </div>
  );
};

export default ComparableCompaniesChartView;
